<script lang="ts">
  import { cn } from '@shared/lib';
  import { Icon } from '@shared/ui/icon';
  import { Loader } from '@shared/ui/loader';

  export let type: 'submit' | 'button' = 'button';
  export let variant: 'secondary' | 'primary' | 'third' = 'primary';
  export let isLoading = false;
  export let hugged = false;
  export let classes = '';
  export let slotClasses = '';

  const variants = {
    primary: 'bg-default-50 text-default-900 hover:bg-electric hover:text-default-50',
    secondary: 'dark:bg-default-50 dark:text-default-900 bg bg-electric text-default-50',
    third: 'bg-default-900 text-default-50 dark:bg-default-50 dark:text-default-900',
  };
</script>

<button
  class="{cn(
    'group flex h-max w-full items-center justify-between gap-4 rounded-[6px] px-4 py-3 transition-colors md:w-max',
    variants[variant],
    { 'w-max md:w-max lg:w-max': hugged },
    classes,
  )}"
  {type}
  on:click
>
  <span class="{cn('text-lg', slotClasses)}"><slot /></span>

  <div class="flex items-center justify-center">
    {#if isLoading}
      <Loader />
    {:else}
      <Icon
        classes="transition-transform duration-300 group-hover:translate-x-1"
        name="arrowRight"
        width="{20}"
        height="{20}"
      />
    {/if}
  </div>
</button>
